import type { PublicSiteLocaleOverride } from '../publicSiteTypes'

export const arPublicSiteOverride = {
  content: {
    brand: {
      tagline: 'خطط تتحرك ولا تتجمد',
    },
    routes: [
      { label: 'نظرة عامة', title: 'تطبيق Timelining', description: 'مساحة تخطيط مرئية مع اقتصاد أرصدة، مراجعة ذكاء اصطناعي، وحلقة RPG تبقي الخطط حية.' },
      { label: 'حلول', title: 'حلول', description: 'تدفقات عمل حقيقية: إطلاق، وكالات، صناع محتوى، طلاب، عمليات ميدانية ومجموعات.' },
      { label: 'الدليل', title: 'الدليل', description: 'شرح كامل من مساحة فارغة إلى خطة منجزة، مع كل سطح ودور ومرحلة.' },
      { label: 'موارد', title: 'موارد', description: 'أنماط جاهزة للنسخ، مكتبة prompts للذكاء الاصطناعي، قوالب checklists وإيقاعات عمل.' },
      { label: 'الأسعار', title: 'الأسعار', description: 'تسعير قائم على الأرصدة. ادفع مقابل ما تستهلكه، لا مقابل المقاعد.' },
      { label: 'تنزيل', title: 'تنزيل', description: 'ثبّت تطبيقي Android Member وHelper من صفحة التنزيل العامة.' },
      { label: 'حول', title: 'حول', description: 'لماذا يوجد هذا التطبيق، ما الذي يمثله، ما الذي تم شحنه، وما القادم.' },
      { label: 'FAQ', title: 'FAQ', description: '25 إجابة حول الإعداد والذكاء الاصطناعي والفرق والبيانات.' },
      { label: 'تواصل', title: 'تواصل', description: 'تواصل معنا للتجارب والدعم والملاحظات والجولات والصحافة.' },
    ],
    hero: {
      eyebrow: 'تخطيط مرئي · اقتصاد أرصدة · مراجعة AI',
      headline: 'خطط تتحرك ولا تتجمد',
      accent: 'تتحرك',
      primaryCtaSignedOut: 'ابدأ التطبيق',
      primaryCtaSignedIn: 'افتح مساحة عملي',
      secondaryCta: 'اقرأ الدليل',
      consoleNoteSignedOut: 'تسجيل الدخول يفتح تجربة التطبيق الخاصة.',
      consoleNoteSignedIn: 'أنت مسجل الدخول. تابع من مساحة عملك الحالية.',
    },
    ctaBand: {
      eyebrow: 'جاهز؟',
      title: 'افتح Console. أو حمّل التطبيق.',
      primary: 'افتح Console',
      secondary: 'احصل على APK',
    },
  },
  chrome: {
    nav: {
      ariaLabel: 'التنقل العام',
      brandHomeSuffix: 'الرئيسية',
      contact: 'تواصل',
      getStarted: 'ابدأ',
      languageLabel: 'اللغة',
      languageAriaLabel: 'لغة الموقع',
    },
    common: {
      openWorkspace: 'افتح مساحة عملي',
      openConsole: 'افتح Console',
      featureColumnHeader: 'الميزة',
      capabilityColumnHeader: 'القدرة',
    },
    download: {
      eyebrow: 'احصل على Timelining',
      title: 'ثبّت تطبيقات Android.',
      downloadApk: 'تنزيل APK',
      copyLink: 'نسخ الرابط',
      share: 'مشاركة',
    },
  },
} satisfies PublicSiteLocaleOverride
